/* PB Grid Reveal — pinned scale-up reveal animation
   Loads GSAP + ScrollTrigger lazily (CDN) only when section is present.
   Fallback: static grid is already usable without JS.
*/
(function () {
  'use strict';

  var GSAP_URL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js';
  var ST_URL = 'https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js';

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[data-pb-gsap="' + src + '"]')) {
        var poll = setInterval(function () {
          if (window.gsap && window.ScrollTrigger) { clearInterval(poll); resolve(); }
        }, 60);
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.dataset.pbGsap = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function ensureGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    return loadScript(GSAP_URL).then(function () { return loadScript(ST_URL); });
  }

  function init(root) {
    if (!root || root.dataset.pbInit === '1') return;
    root.dataset.pbInit = '1';

    var sticky = root.querySelector('[data-pb-grv-sticky]');
    var middle = root.querySelector('[data-pb-grv-mid]');
    var textEl = root.querySelector('[data-pb-grv-text]');
    if (!sticky || !middle || !textEl) return;

    var startText = root.dataset.startText || 'SOLO MISSION?';
    var endText = root.dataset.endText || 'NOT WITH BROLIC';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      textEl.innerText = endText;
      return;
    }

    ensureGsap().then(function () {
      var gsap = window.gsap;
      var ScrollTrigger = window.ScrollTrigger;
      if (!gsap || !ScrollTrigger) return;
      gsap.registerPlugin(ScrollTrigger);

      var cells = Array.prototype.slice.call(
        root.querySelectorAll('.pb-grv__cell:not(.pb-grv__cell--mid)')
      );
      if (!cells.length) return;

      var isMobile = window.innerWidth <= 1024;
      var startScale = isMobile ? 1.5 : 3;

      gsap.set(middle, { scale: startScale, zIndex: 25, transformOrigin: 'center center' });
      gsap.set(cells, { scale: 0.2, opacity: 0, transformOrigin: 'center center' });

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: sticky,
          start: isMobile ? 'top 70%' : 'center center',
          end: 'bottom top',
          scrub: 1.5,
          pin: !isMobile,
          pinSpacing: true,
          anticipatePin: 1,
          invalidateOnRefresh: true
        }
      });

      tl.to(middle, { scale: 1, duration: 0.6, ease: 'power2.inOut' })
        .to(cells, {
          scale: 1, opacity: 1, duration: 1,
          stagger: { amount: 0.8, from: 'center', grid: [3, 5] },
          ease: 'back.out(1.4)'
        }, '-=0.5');

      var currentText = startText;
      ScrollTrigger.create({
        trigger: sticky,
        start: isMobile ? 'top 70%' : 'center center',
        end: 'bottom top',
        onEnter: function () {
          if (currentText === startText) {
            gsap.to(textEl, { opacity: 0, duration: 0.3, onComplete: function () {
              textEl.innerText = endText;
              currentText = endText;
              gsap.to(textEl, { opacity: 1, duration: 0.3 });
            } });
          }
        },
        onLeaveBack: function () {
          if (currentText !== startText) {
            gsap.to(textEl, { opacity: 0, duration: 0.3, onComplete: function () {
              textEl.innerText = startText;
              currentText = startText;
              gsap.to(textEl, { opacity: 1, duration: 0.3 });
            } });
          }
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.pb-grv').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.pb-grv');
    if (root) init(root);
  });
})();
